module.exports = "/images/Sub-HeroM.jpg";